import React from "react";
import styled from "styled-components";

const OuiOverflowScroll = ({ children }) => {
  return (
    <StyledOuiOverflowScroll>
      {children}
    </StyledOuiOverflowScroll> 
  );
};

export default OuiOverflowScroll;

const StyledOuiOverflowScroll = styled.div`
  position: relative;
  max-height: calc(100% - 1em);
  margin: 0.5em;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  --size: 0.25em;
  &::-webkit-scrollbar {
    width: var(--size);
    border-radius: 0.5em;
  }
  &::-webkit-scrollbar-track {
    width: var(--size);
    height: var(--size);
    background-color: var(--theme-oui-background-against-light);
    border-radius: 0.5em;
    box-shadow: inset 0 0 0.125em rgba(0,0,0,0.1);
  }
  &::-webkit-scrollbar-thumb {
    height: 0.25em;
    width: 0.25em;
    background: #afafaf;
    //border: 2px solid #dfdfdf;
    border-radius: 0.5em;
  }
`;